var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaterialCreateNewFolder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 16.8,
    viewBox: "0 0 21 16.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-create-new-folder",
    "data-name": "Icon material-create-new-folder",
    d: "M21.9,8.1H13.5L11.4,6H5.1A2.084,2.084,0,0,0,3.01,8.1L3,20.7a2.093,2.093,0,0,0,2.1,2.1H21.9A2.093,2.093,0,0,0,24,20.7V10.2A2.093,2.093,0,0,0,21.9,8.1Zm-1.05,8.4H17.7v3.15H15.6V16.5H12.45V14.4H15.6V11.25h2.1V14.4h3.15Z",
    transform: "translate(-3 -6)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialCreateNewFolder);
export default __webpack_public_path__ + "static/media/material-create-new-folder.312d7a70cd822579c580eed92925dd20.svg";
export { ForwardRef as ReactComponent };